export namespace MediaFile {
  export const addNameSuffix = (name, suffix) => name.includes('.') ? name.replace(/\.(?!.*\.)/, `_${suffix}.`) : `${name}_${suffix}`;
}
